import { constantsData, formFieldNamesData } from "@/data";
import { optionsData } from "@/data/options";
import { FieldTypeEnum } from "@/enums";

const {
    dataAction,
    nameSeparator,
} = constantsData.forms.dataSources.transform.name;

const {
    dataAction: dataActionFieldName,
    nameSeparator: nameSeparatorFieldName,
} = formFieldNamesData;

export const transformOfflineDataSourceNameFieldFormData = [
    {
        description: dataAction.description,
        hasOptionFormat: true,
        label: dataAction.label,
        name: dataActionFieldName,
        options: optionsData.dataSource.transform.name.dataActions,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: nameSeparator.description,
        label: nameSeparator.label,
        name: nameSeparatorFieldName,
        options: optionsData.dataSource.transform.name.separators,
        type: FieldTypeEnum.SELECT,
    },
];
